export const ESTADO_INVITACION_ASESORIA = {
  PENDIENTE: 1,
  ACEPTADA: 2,
  RECHAZADA: 3,
} as const

export type EstadoInvitacionAsesoriaType =
  (typeof ESTADO_INVITACION_ASESORIA)[keyof typeof ESTADO_INVITACION_ASESORIA]
